import * as React from "react";
import { Loader } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";
import { OrgStructureDetailModel } from "@teamprevent/common/orgStructure/models";

import { useCustomerDetailsModel } from "../../../crud/customer/hooks";
import { orgStructureApi } from "../../../crud/orgStructure";

interface Props {
    billableCustomerId: string;
    value: string;
    onChange: (value: OrgStructureDetailModel | undefined, valid: boolean) => void;
    showErrors: boolean;
}

export const BillableOrgStructure1Dropdown = ({ onChange, ...props }: Props) => {
    const {
        customer: billableCustomer,
        isLoaded: customerLoaded,
        isLoading: customerLoading
    } = useCustomerDetailsModel({ customerId: props.billableCustomerId });
    const showOrgStructureDropdown = React.useMemo(() => customerLoaded ? billableCustomer.orgLevel1Billing : null, [billableCustomer, customerLoaded]);
    const [orgStructures, setOrgStructures] = React.useState<OrgStructureDetailModel[] | null>(null);
    const onDropdownChange = React.useCallback(
        (value: string) => {
            const orgStructure = orgStructures?.find(o => o.id === value);
            onChange(orgStructure, !!orgStructure);
        }, [onChange, orgStructures]);
    React.useEffect(() => {
        (async () => {
            if (props.billableCustomerId === undefined || showOrgStructureDropdown !== true) {
                setOrgStructures(null);
                return;
            }
            if (orgStructures?.every(o => o.customerId === props.billableCustomerId)) {
                return;
            }

            setOrgStructures(null);
            const loadedOrgStructures = await orgStructureApi.getAll(props.billableCustomerId);
            setOrgStructures(loadedOrgStructures);
            const orgStructure = loadedOrgStructures.find(o => o.id === props.value);
            onChange(orgStructure, !!orgStructure);
        })();
    }, [orgStructures, props.billableCustomerId, onChange, props.value, showOrgStructureDropdown]);
    React.useEffect(() => {
        if (showOrgStructureDropdown === false) { onChange(undefined, true); }
    }, [showOrgStructureDropdown, onChange]);

    if (showOrgStructureDropdown === false) {
        return null;
    }

    if (customerLoading || orgStructures === null) {
        return <Loader active />;
    }

    return (<Input.Dropdown
        dynamicOptions
        required
        label="Billable Org Level 1"
        value={props.value}
        showErrors={props.showErrors}
        options={orgStructures.map(o => ({ key: o.id, value: o.id, text: o.name }))}
        onChange={onDropdownChange}
    />);
};
